var React = require('react');

function ChevronLeft (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M14.7803 5.21967C14.5141 4.9534 14.0974 4.9292 13.8038 5.14705L13.7197 5.21967L7.71967 11.2197C7.4534 11.4859 7.4292 11.9026 7.64705 12.1962L7.71967 12.2803L13.7197 18.2803C14.0126 18.5732 14.4874 18.5732 14.7803 18.2803C15.0466 18.0141 15.0708 17.5974 14.8529 17.3038L14.7803 17.2197L9.311 11.75L14.7803 6.28033C15.0466 6.01406 15.0708 5.5974 14.8529 5.30379L14.7803 5.21967Z","fill":"#313335"}));
}

ChevronLeft.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none"};

module.exports = ChevronLeft;

ChevronLeft.default = ChevronLeft;
